import util from '@utils/util';
import logreg from '../js/logreg';
import api from '../js/api';
export default {
  name: 'verificatewrap',
  props: {
    mb: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    itc: {
      type: String,
      default: ''
    },
    country: {
      type: String,
      default: ''
    },
    imgCode: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 4
    }
  },
  data: function data() {
    return {
      code: '',
      codeError: '',
      count: 60,
      countState: false
    };
  },
  components: {},
  methods: {
    codeInput: function codeInput() {
      if (!this.code) {
        this.codeError = this.$t(this.$loginLangPrefix('userSign.codeError'));
      } else if (logreg.validate(this.code, 'phone')) {
        this.codeError = '';
      } else {
        this.codeError = this.$t(this.$loginLangPrefix('userSign.codeError'));
      }
      this.$emit('changeCode', this.code);
      this.$emit('changeCodeError', this.codeError);
    },
    verification: function verification() {
      var _this = this;
      if (!this.imgCode) {
        this.$emit('changeImgCodeError', this.$t(this.$loginLangPrefix('userSign.codeError')));
        return;
      }
      if (!this.countState && this.imgCode) {
        api.sendRegCode(this.name, this.itc, this.country, this.imgCode, this.type).then(function (data) {
          if (data.ret === '1') {
            // 验证码发送成功
            _this.countState = true;
            _this.countDown();
          } else {
            _this.codeError = _this.$t(_this.$loginLangPrefix('userSign.codeSendError'));
            _this.$emit('changeCodeError', _this.codeError);
            _this.$emit('changeImgCodeValue');
          }
        }).catch(function (response) {
          _this.$emit('changeCodeError', _this.codeError);
          _this.$emit('changeImgCodeValue');
          if (response.errorMessageTMXTip) {
            return;
          }
          _this.codeError = _this.$t(_this.$loginLangPrefix('userSign.codeSendError'));
        });
        util.KEWLSensorTrack({
          lmweb_clickText: '获取验证码'
        });
      }
    },
    countDown: function countDown() {
      var _this2 = this;
      var num = 60;
      var timer = null;
      if (!timer) {
        timer = setInterval(function () {
          num -= 1;
          _this2.count = num;
          if (_this2.count === 0) {
            clearInterval(timer);
            _this2.countState = false;
            _this2.count = 60;
            timer = null;
          }
        }, 1000);
      }
    },
    next: function next() {
      this.$emit('btnSure');
    }
  },
  // watch: {
  //     // codeError(val) {
  //     //     this.$emit('changeCodeError', val);
  //     // }
  // },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};